import { Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

type CheckoutPriceSummaryProps = {
  title: string;
  price: ReactNode;
  description: string;
  descriptionVisible?: boolean;
  priceTestId?: string;
};

export const CheckoutPriceSummary = (
  props: CheckoutPriceSummaryProps,
): JSX.Element => {
  const {
    title,
    price,
    description,
    descriptionVisible = true,
    priceTestId,
  } = props;

  return (
    <Stack spacing={1}>
      <Stack
        spacing={1}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Typography variant="h3" fontWeight="fontWeightBold">
          {title}
        </Typography>

        <Typography
          variant="h3"
          component="p"
          fontWeight="fontWeightRegular"
          data-testid={priceTestId}
        >
          {price}
        </Typography>
      </Stack>

      {descriptionVisible && (
        <Typography variant="body2">{description}</Typography>
      )}
    </Stack>
  );
};
